import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'

import { LegalPage } from '@/components/site/legal-page'
import { useLocale } from '@/i18n/use-locale'
import { siteLegal } from '@/i18n/site-legal'

const PrivacyPage: FC = (): ReactNode => {
    const locale = useLocale()
    return <LegalPage legal={siteLegal[locale].privacy} path='/privacy' />
}

export const getStaticProps: GetStaticProps = async () => ({ props: {} })

export default PrivacyPage
